import {
  BUTTON_SUBMISSION, MY_ACCOUNT_SETTINGS, OVERLAY
} from '../constants';

export const orderCommunications = () => {

  const ORDER_COMMS_OVERLAY = 'projects: order communications';
  const ORDER_COMMS_SIGN_IN_OVERLAY = 'projects: order communications sign in prompt';
  const ORDER_COMMS_OVERLAY_SETTINGS = 'projects: order communications overlay';
  const PROJECT_SETUP_USER_DELETED = 'projects: project details: project setup: user deleted';

  // Only these actions are beaconed, so an unexpected value from the UI can't create new Adobe line items.
  const ORDER_COMMS_ACTIONS = {
    search: 'search',
    'users-added': 'users added',
    pagination: 'pagination click',
    'sign-in': 'sign in click',
    'create-user': 'create user click',
    'user-deleted': 'user deleted',
  };

  // 1.6 Order Communications Overlay and Sign In Overlay
  LIFE_CYCLE_EVENT_BUS.on('order-communications.overlay', (data) => {
    const { signInPrompt } = data?.output || {};
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: signInPrompt ? ORDER_COMMS_SIGN_IN_OVERLAY : ORDER_COMMS_OVERLAY,
      }
    };
    digitalData.event.push(ddoEvent);
  });

  // 1.6.1 Delete Users / 1.6.2 Actions in Order Communications Overlay
  LIFE_CYCLE_EVENT_BUS.on('order-communications.action', (data) => {
    const { action, source } = data?.output || {};
    if (!Object.prototype.hasOwnProperty.call(ORDER_COMMS_ACTIONS, action)) return;
    const actionValue = ORDER_COMMS_ACTIONS[action];

    const settings = action === 'user-deleted' && source === 'project-setup'
      ? PROJECT_SETUP_USER_DELETED
      : `${ORDER_COMMS_OVERLAY_SETTINGS}: ${actionValue}`;
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS
      },
      myAccount: {
        settings
      }
    };
    digitalData.event.push(ddoEvent);
  });
};
